import React from "react";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import "styles/components/FormTextField.scss";

const FormTextField = ({
	controlId,
	label,
	value,
	onChange,
	placeholder = "",
	isInvalid = false,
	error = "",
	required = false,
	type = "text",
	className = "",
}) => (
	<FormGroup className={`form-group form-text-field ${className}`.trim()} controlId={controlId}>
		<FormLabel className="form-text-field__label">
			{label}
			{required && <span className="label-required"> *</span>}
		</FormLabel>
		<FormControl
			type={type}
			value={value}
			onChange={onChange}
			placeholder={placeholder}
			isInvalid={isInvalid}
		/>
		<FormControl.Feedback type="invalid">{error}</FormControl.Feedback>
	</FormGroup>
);

export default FormTextField;
